<template>
  <h3 v-if="showTitle" class="text-black md:text-[1.6rem] sm:text-[1.6rem] font-medium">{{$t('services')}}</h3>
  <div :class="showTitle ? 'mt-0' : 'mt-[2.4rem]' + ' mt-[1.1rem]'">
    <TextList
      :list="services"
      :max-items="maxItems"
      :showMoreContentBtn="showMoreContentBtn"
    />
  </div>

</template>

<script>

import TextList  from '@/components/form/textList.vue';

export default {
  name: 'servicesComponent',
  components: {
    TextList
  },
  props: {
    services: {
      type: Array,
      required: true,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showMoreContentBtn: {
      type: Boolean,
      default: true,
    },
    maxItems: {
      type: Number,
      default: 3,
    },
  },
}
</script>

<style scoped>

</style>
